import { SubmissionError } from 'redux-form'
import { rest } from 'services'
import { refresh } from 'actions/router'

export const updatePassword = (email, passwordData) => (dispatch, getState) =>
  rest.api
    .updatePassword({
      ...passwordData,
      email
    })
    .then(() => dispatch(refresh()))
    .catch(err => {
      throw new SubmissionError({
        _error: err.errors[0]
      })
    })
